interface MediaItem {
  image: string;
  title: string;
  tag: string;
  desc: string;
  duration: string;
}

const mediaItems: MediaItem[] = [
  {
    image: 'https://readdy.ai/api/search-image?query=Anime%20style%20illustration%20of%20a%20sword%20fighter%20battling%20demons%20in%20a%20moonlit%20forest%2C%20dramatic%20lighting%2C%20action%20scene%2C%20Japanese%20anime%20art%2C%20dynamic%20composition%2C%20vivid%20colors%2C%20high%20quality%20digital%20painting&width=800&height=500&seq=91sakura-media-01&orientation=landscape',
    title: '鬼灭之刃 无限城篇',
    tag: '热血战斗',
    desc: '炭治郎与伙伴们深入无限城，与上弦之鬼展开最终决战。',
    duration: '剧场版',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Anime%20art%20illustration%20of%20an%20elf%20mage%20walking%20through%20a%20peaceful%20countryside%20with%20companions%2C%20warm%20golden%20hour%20lighting%2C%20fantasy%20medieval%20setting%2C%20soft%20pastel%20colors%2C%20beautiful%20landscape%2C%20Japanese%20anime%20style&width=800&height=500&seq=91sakura-media-02&orientation=landscape',
    title: '葬送的芙莉莲 第二季',
    tag: '奇幻治愈',
    desc: '芙莉莲的旅途继续，与新同伴一起探索魔法的真谛。',
    duration: '连载中',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Anime%20illustration%20of%20a%20mysterious%20dark%20haired%20boy%20with%20supernatural%20powers%20in%20a%20modern%20urban%20setting%2C%20dramatic%20shadows%2C%20neon%20accents%2C%20dark%20fantasy%20atmosphere%2C%20Japanese%20anime%20art%20style&width=800&height=500&seq=91sakura-media-03&orientation=landscape',
    title: '咒术回战 死灭回游',
    tag: '黑暗奇幻',
    desc: '虎杖与伏黑全面迎战，咒术界的命运悬于一线。',
    duration: '连载中',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Anime%20art%20of%20a%20beautiful%20idol%20singer%20on%20stage%20with%20colorful%20spotlights%2C%20sparkling%20atmosphere%2C%20Japanese%20pop%20idol%20aesthetic%2C%20dreamy%20lighting%2C%20stunning%20performance%20scene%2C%20high%20quality%20illustration&width=800&height=500&seq=91sakura-media-04&orientation=landscape',
    title: '我推的孩子 第三季',
    tag: '悬疑偶像',
    desc: '娱乐圈背后的真相逐渐浮出水面，爱与复仇交织。',
    duration: '即将上线',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">热门推荐</h2>
          <p className="text-sm text-foreground-500 max-w-xl mx-auto">当前91樱花平台最受关注的热门动漫作品推荐</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {mediaItems.map((item, idx) => (
            <div key={idx} className="group bg-background-100 rounded-xl overflow-hidden border border-background-200/70 hover:border-primary-200 transition-all duration-300">
              <div className="relative w-full h-44 overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  title={item.title}
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent"></div>
                <span className="absolute bottom-3 right-3 px-2 py-0.5 rounded bg-background-50/90 text-xs font-medium text-foreground-700 whitespace-nowrap">
                  {item.duration}
                </span>
              </div>
              <div className="p-4">
                <span className="inline-block px-2 py-0.5 rounded-full bg-primary-100 text-primary-700 text-xs font-medium mb-2 whitespace-nowrap">
                  {item.tag}
                </span>
                <h3 className="font-heading text-sm md:text-base text-foreground-900 mb-1">{item.title}</h3>
                <p className="text-xs text-foreground-500 leading-relaxed">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}